import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useFacultyEdit } from '@/module/Faculty/model/FacultyQuery';
import { FacultySchema, defaultFacultyValues, facultySchema } from '@/module/Faculty/model/FacultySchema';

import { useAppNotification } from '@feature/utils';

import { FacultyForm } from './FacultyForm';
import { Faculty } from './model/FacultyTypes';

interface FacultyEditProps {
  faculty: Faculty;
}

const convert = (faculty: Faculty): FacultySchema => ({
  ...faculty,
});

export function FacultyEdit(props: FacultyEditProps) {
  const { faculty } = props;
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useFacultyEdit(faculty.id);

  const notification = useAppNotification();
  const onSubmit = (values: FacultySchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: notification.success,
    });
  };

  const values = useMemo(() => convert(faculty), [faculty]);
  const navigate = useNavigate();

  return (
    <FacultyForm
      title={t('faculties.form.title.edit')}
      schema={facultySchema}
      defaultValues={defaultFacultyValues}
      isError={isError}
      isSuccess={isSuccess}
      values={values}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
